import React from 'react';

const PINActivitySection = ({ pinActivity, formatDate }) => {
  let parsedPinActivity = [];

  try {
    parsedPinActivity = JSON.parse(pinActivity || '[]');
  } catch (error) {
    parsedPinActivity = [];
  }

  if (!Array.isArray(parsedPinActivity) || parsedPinActivity.length === 0) {
    return null;
  }

  return (
    <div className="container">
      <h6 className="text-dark mt-2">PIN Activity</h6>
      <div className="col-12">
        {parsedPinActivity.map((item, key) => (
          <div className="row px-3" key={key}>
            <div className="col-12 mb-2">
              <div className="row ">
                {[
                  { className: 'col-4 col-md-4 col-lg-4 mt-2 pt-1', value: item.ActivityDateTime ? formatDate(item.ActivityDateTime) : '', label: 'Date/Time', name: '' },
                  { className: 'col-4 col-md-4 col-lg-4 mt-2 pt-1', value: item.OfficerName, label: 'Officer Name', name: 'OfficerName' },
                  { className: 'col-4 col-md-4 col-lg-4 mt-2 pt-1', value: item.ActivityRole, label: 'Role', name: 'OfficerName' },
                  { className: 'col-4 col-md-4 col-lg-4 mt-2 pt-1', value: item.ActivityStatus, label: 'Activity Details', name: 'OfficerName' },
                  { className: 'col-4 col-md-4 col-lg-4 mt-2 pt-1', value: item.ResourceNumber, label: 'Module', name: 'OfficerName' },
                  { className: 'col-4 col-md-4 col-lg-4 mt-2 pt-1', value: item.ShiftDescription, label: 'Shift', name: 'OfficerName' },
                ].map((field, index) => (
                  <div className={field.className} key={index}>
                    <div className="text-field">
                      <input
                        type="text"
                        className={field.inputClass || 'readonlyColor'}
                        name={field.name || ''}
                        required
                        readOnly
                        value={field.value}
                      />
                      <label htmlFor="" className="new-summary">{field.label}</label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PINActivitySection;
